import { X } from 'lucide-react';
import { format } from 'date-fns';

interface SkipDeliveryModalProps {
  show: boolean;
  onClose: () => void;
  onSkip: () => void;
  nextDeliveryDate?: string | null;
  loading: boolean;
}

const SkipDeliveryModal: React.FC<SkipDeliveryModalProps> = ({
  show,
  onClose,
  onSkip,
  nextDeliveryDate,
  loading
}) => {
  if (!show) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Skip Next Delivery</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <p className="text-gray-600 mb-3">
          Your next delivery is scheduled for {nextDeliveryDate && format(new Date(nextDeliveryDate), 'EEEE, MMMM d, yyyy')}.
        </p>
        <p className="text-gray-600 mb-6">
          If you skip this delivery, your subscription will be extended by one delivery cycle.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={onSkip}
            className="flex-1 py-3 bg-[#F9D348] text-black rounded-lg font-medium flex justify-center items-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin mr-2"></div>
                Processing...
              </>
            ) : (
              'Skip Delivery'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkipDeliveryModal; 